import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 's1-date-picker',
  templateUrl: './s1-date-picker.component.html',
  styleUrls: ['./s1-date-picker.component.scss']
})
export class S1DatePickerComponent implements OnInit {

  @Input() date: Date;
  @Input() label: string;
  @Input() dark: boolean = false;

  @Output() dateChange = new EventEmitter<Date>();

  datepicker: any = {
    config: {
      customTodayClass: 'custom-today-class',
      dateInputFormat: 'DD/MM/YYYY',
      isAnimated: true,
      adaptivePosition: true,
      containerClass: 'theme-dark-blue'
    },
    maxDate: null,
    minDate: null
  };

  constructor() { }

  ngOnInit() {
  }

  updateDate() {
    this.dateChange.emit(this.date);
  }

}
